import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { MaskLines, Overline, EASE } from "./Motion";
import { WORKSPACES } from "../../lib/site";

const Card = ({ w, i, onEnquire }) => {
  const Icon = w.icon;
  return (
    <motion.article
      initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.9, ease: EASE, delay: (i % 3) * 0.08 }}
      data-testid={`workspace-card-${w.slug}`}
      className="group flex flex-col rounded-[24px] border border-white/10 bg-[#131924] p-3 transition-[border-color,transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:border-[#D4AF37]/40 hover:shadow-[0_30px_80px_-30px_rgba(212,175,55,.25)]"
    >
      <div className="relative aspect-[4/3] overflow-hidden rounded-[18px]">
        <img src={w.img} alt={w.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-110" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0F17]/70 via-transparent to-transparent" />
        <span className="absolute left-3 top-3 grid h-11 w-11 place-items-center rounded-xl bg-[#0B0F17]/70 backdrop-blur-md border border-white/10 text-[#D4AF37]">
          <Icon className="h-5 w-5" />
        </span>
        <span className="font-mono-k absolute right-4 top-4 text-xs text-white/80">{String(i + 1).padStart(2, "0")}</span>
      </div>
      <div className="flex flex-1 flex-col px-3 pb-3 pt-5">
        <h3 className="font-display text-xl sm:text-2xl font-medium tracking-tight text-white">{w.name}</h3>
        <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-400">{w.desc}</p>
        <div className="mt-6 flex items-center justify-between gap-3 border-t border-white/10 pt-4">
          <span className="font-mono-k text-[11px] uppercase tracking-[0.18em] text-[#E3C45A]">Contact Us for Pricing</span>
          <button onClick={() => onEnquire(w.name)} data-testid={`workspace-enquire-${w.slug}`}
            className="inline-flex shrink-0 whitespace-nowrap items-center gap-1.5 rounded-full bg-white/[0.06] px-4 py-2 text-sm text-white transition-colors hover:bg-[#D4AF37] hover:text-[#0B0F17]">
            Enquire Now <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
          </button>
        </div>
      </div>
    </motion.article>
  );
};

export const Workspaces = ({ onEnquire }) => (
  <section id="workspaces" data-testid="workspaces-section" className="relative bg-[#0E131D] py-24 lg:py-36">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <Overline>Workspace Solutions</Overline>
          <MaskLines className="font-display mt-6 text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-[-0.03em] leading-[1.02] text-white"
            lines={["Nine ways to work.", <span className="text-slate-400">One standard of comfort.</span>]} />
        </div>
        <p className="max-w-sm text-slate-400">From a single desk for a day to a fully configured corporate floor — tell us what you need and we'll tailor it.</p>
      </div>
      <div className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {WORKSPACES.map((w, i) => <Card key={w.slug} w={w} i={i} onEnquire={onEnquire} />)}
      </div>
    </div>
  </section>
);
